const DEFAULT_IMAGE_MIME = "image/png";

const detectImageMime = (value) => {
  if (!value || typeof value !== "string") {
    return DEFAULT_IMAGE_MIME;
  }

  if (value.startsWith("data:image/")) {
    const match = value.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,/);
    return match ? match[1] : DEFAULT_IMAGE_MIME;
  }

  const signature = value.slice(0, 20);
  if (signature.startsWith("/9j/") || signature.startsWith("/9J/")) {
    return "image/jpeg";
  }
  if (signature.startsWith("iVBOR")) {
    return "image/png";
  }
  if (signature.startsWith("R0lGOD")) {
    return "image/gif";
  }
  if (signature.startsWith("Qk")) {
    return "image/bmp";
  }
  return DEFAULT_IMAGE_MIME;
};

const arrayBufferToBase64 = (bufferData) => {
  if (!bufferData || !Array.isArray(bufferData)) {
    return null;
  }

  const bytes = Uint8Array.from(bufferData);
  const chunkSize = 0x8000;
  let binary = "";

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }

  return window.btoa(binary);
};

export const normalizeImageValue = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  if (value?.type === "Buffer" && Array.isArray(value?.data)) {
    return arrayBufferToBase64(value.data);
  }

  return null;
};

export const buildImageSrc = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }
  if (value.startsWith("data:image/")) {
    return value;
  }
  const mime = detectImageMime(value);
  return `data:${mime};base64,${value}`;
};
